import type { GaApp } from '~/modules/app'

export const getters = (gaApp: GaApp) => ({
  hasModals(): boolean {
    return gaApp.stores.modal.register.modals.length > 0
  },
})
